import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { connect } from 'react-redux';
import { Dispatch, QueryRequest, store } from '../../../utils/types';
import { updateCurrentQueryDetiails } from '../../../actions/query';

const { Option } = Select;

const NetworkName = ({ values, setValues, categoryStructure }: any) => {
  const [networkNames, setNetworkNames] = useState<string[]>([]);

  useEffect(() => {
    const networkTypes = Object.keys(categoryStructure);
    const nt = values.networkType ? values.networkType : networkTypes[0];
    setValues({ ...values, networkType: nt });
    setNetworkNames(Object.keys(categoryStructure[nt]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryStructure]);

  const onChange = (value: string) => {
    setValues({
      ...values,
      networkName: value,
      cohortDiseaseName: undefined,
      search: [],
      categoryId: undefined,
      locations: [],
    });
  };

  return (
    <div id="network-name-select">
      <Form.Item labelCol={{ span: 24 }} label="Network">
        <Select
          value={values.networkName}
          onChange={onChange}
          placeholder="Select"
          className="w-full rounded-select"
        >
          {networkNames.map((o: any, i: any) => (
            <Option key={i} value={o}>
              {o}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
};

const mapStateToProps = (state: store) => ({
  values: state.query.currentQueryDetails,
  categoryStructure: state.dataTypes.catStructure,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setValues: (currentQueryDetails: QueryRequest) =>
    dispatch(updateCurrentQueryDetiails(currentQueryDetails)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NetworkName);
